export default __webpack_public_path__ + "e92b0d15329272f64939005a2ad5b6d3.svg";